import script from "./TimeSince.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimeSince.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__